import SiafLiteNfeRepository from "../../external/siafLiteNfe";

class NfeService {
  constructor() {
    this.urlBase = "/nfce";
  }

  baixarXml(cnpj, ano, mes) {
    return new SiafLiteNfeRepository(
      `${this.urlBase}/${cnpj}/xml/${ano}/${mes}`
    ).getFile();
  }

  baixarXmlIndividual(cnpjCpf, chaveXml) {
    return new SiafLiteNfeRepository(
      `${this.urlBase}/${cnpjCpf}/consulta-sefaz/${chaveXml}`
    ).get();
  }
}

export default NfeService;
